var Quiz = {
	node :null,
	current: null,

	init: function() {
		Quiz.bootstrap();
	},

	register: function() {

		Tab.setGroup("quest.wcagicon", "+");
		Tab.setGroup("quest.wcag", "+");
		Tab.setGroup("quest.quiz", "+");
		Tab.setGroup("quest.scorewidget", "+");
		Tab.setGroup("quest.scoreboard", "+");

		AppEvent.on(player, "VOLUME.SET", function() {
			$('.qaudio').each(function(idx, item) {
				item.volume = Volume.currentMusicVolume();
			});
		});

		AppEvent.on(player, "PLACE.LOADED", Quiz.placeReady);

		AppEvent.on(player, "VOLUME.UI.SHOW", function() {
			$('#scorewidget').hide();
		});

		AppEvent.on(player, "VOLUME.UI.HIDE", function() {
			$('#scorewidget').show();
		});
	},

	bootstrap: function() {
//		Quiz.node = $("<div id='quiz' class='quiz-main'><qwin></qwin></div>");
		Quiz.node = $("<div id='quiz' class='quiz-main'><qwin ref='qwin'></qwin><questwin ref='questwin'></questwin><pqwin ref='pqWin'></pqwin></div>");

		$("#panels").append(Quiz.node);

		Vue.component('wcag', Quiz.wcag);
		Vue.component('qwin', Quiz.qwin);
		Vue.component('questwin', Quiz.questwin);
		Vue.component('pqwin', Quiz.pqWin);

		Quiz.vue = new Vue({
			el: '#quiz'
		});

	},

	open: function(id) {
		Quiz.vue.$refs.qwin.open(id);
	},

	quest: function(id, img, ret) {
		var first = Quiz.notfirst == undefined ? "1" : "";
		Quiz.vue.$refs.questwin.open(id, img, ret, first);
		Quiz.notfirst = 1;
	},

	placeReady: function(pe) {
		Quiz.vue.$refs.pqWin.close();
	},

	process: function() {
	},

	ssi: function(className, method, params, fun) {
			
		var request = {};
						
		request.className = className;
		request.methodName = method;
						
		for(var propertyName in params) {
			request["parameters!" + propertyName] = params[propertyName];
		}
											
		$.ajax({						
			type: "POST",
			url: "/gatewayManager.php?result=json",
			dataType: "json",
			data: request
		}).done(function( resp ) {
			fun(resp);
		});
	}

}

PluginManager.add(Quiz);